module.exports = __webpack_public_path__ + "static/img/4-3.b259c07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/4-3.jpg
// module id = u7BF
// module chunks = 25